import { forwardRef, useState } from "react";

import { Core } from "..";

import { useTheme } from "styled-components";

// eslint-disable-next-line react/display-name
export const Password = forwardRef((props, ref) => {
  const theme = useTheme();
  const [visible, setVisible] = useState(false);

  return (
    <Core
      {...props}
      ref={ref}
      suffix={{
        icon: {
          name: visible ? "ClosedEye" : "Eye",
          position: "right",
          color: theme.colors.neutral.white,
        },
        action: () => setVisible(!visible),
      }}
      type={visible ? "text" : "password"}
    />
  );
});
